// @flow

// Extracts the IDs from an array of Services and returns an array containing
// only the IDs. Because service IDs can be null or undefined, we remove null
// and undefined values from the array.
//
// Because Flow doesn't understand type refinements using
// Array.prototype.filter, we have to cast the resulting items to any, and then
// to string, to force Flow to understand that they are definitely strings at
// this point. :-(
//
// https://github.com/facebook/flow/issues/1414
// https://flow.org/en/docs/types/casting/#toc-type-casting-through-any

export type ServiceAction = $Shape<{|
  helpText?: ?string,
  helpTextHtml?: ?string,
  hide?: ?boolean,
  hookDirectionsHtml?: ?string,
  hookLegacyUrl?: ?string,
  hookUrl?: ?string,
  important?: ?boolean,
  isHook?: ?boolean,
  isHook?: ?boolean,
  isHookNotification?: ?boolean,
  isHookPollable?: ?boolean,
  isHookSubscription?: ?boolean,
  key?: ?string,
  label?: ?string,
  needs?: ?any,
  noun?: ?string,
  searchDelegate?: ?string,
  typeOf?: ?string,
  writeDelegate?: ?string,
  __typename: any,
|}>;

export type ServiceActionMap = $Shape<{|
  reads?: ?Array<?ServiceAction>,
  writes?: ?Array<?ServiceAction>,
  searches?: ?Array<?ServiceAction>,
  __typename?: ?string,
|}>;

export type ServiceCategory = $Shape<{|
  id?: ?string,
  name?: ?string,
  slug?: ?string,
  __typename: 'ServiceCategory',
|}>;

export type ServiceImages = $Shape<{|
  url_128x128?: ?string,
  url_16x16?: ?string,
  url_32x32?: ?string,
  url_64x64?: ?string,
|}>;

export type Service = $Shape<{|
  actions?: ?ServiceActionMap,
  ageInDays?: ?number,
  appId?: ?string,
  appUrl?: ?string,
  authType?: ?string,
  banner?: ?string,
  categories?: ?Array<?ServiceCategory>,
  daysSinceLastUpdate?: ?number,
  description?: ?string,
  hashTag?: ?string,
  hasFilters?: ?boolean,
  hasReads?: ?boolean,
  hasSearches?: ?boolean,
  hasSearchesOrWrites?: ?boolean,
  hasUpfrontFields?: ?boolean,
  hasWrites?: ?boolean,
  id?: ?string,
  image?: ?string,
  images?: ?ServiceImages,
  integrationOverviewHtml?: ?string,
  isBeta?: ?boolean,
  isBuiltIn?: ?boolean,
  isDeprecated?: ?boolean,
  isFeatured?: ?boolean,
  isHidden?: ?boolean,
  isInvite?: ?boolean,
  isPremium?: ?boolean,
  isPublic?: ?boolean,
  isUpcoming?: ?boolean,
  inviteUrl?: ?string,
  key?: ?string,
  learnMoreUrl?: ?string,
  metaServiceUpdates?: ?any,
  name?: ?string,
  popularity?: ?number,
  primaryColor?: ?string,
  serviceId?: ?number,
  sharingTags?: ?string,
  slug?: ?string,
  updates?: ?any,
  url?: ?string,
  zapUsageCount?: ?number,
  requestCount?: ?number,
  __typename: any,
|}>;

export const getServiceIds = (services: Array<?Service>): ?(string[]) => {
  if (!services) return undefined;

  return services
    .map(service => service && service.id)
    .filter(id => Boolean(id))
    .map(id => ((id: any): string));
};

export default getServiceIds;
